export default {
  // 导出
  export: "runUser_export",
  // 查看
  look: "runUser_look",
  // 修改
  edit: "runUser_edit",
  // 冻结/解冻
  freeze: "runUser_freeze",
}